module.exports = __webpack_public_path__ + "static/media/m-kkaeda-sagac.d0b1e7d7.png";